import PaidOrders from '../views/paidorders/list.vue'

export default [
  {
    path: '/paidorders',
    name: 'paidorders',
    component: PaidOrders,
  }
]